/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { KTSVG } from '../../../../../_metronic/helpers'
import { LanguageHelp } from '../../../../../_metronic/helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import { updateReviewStatus } from './core/_requests'
import { useQueryResponse } from './core/QueryResponseProvider'
import { useQueryClient } from 'react-query'
import { ID, QUERIES } from '../../../../../_metronic/helpers'
import { ReviewListLoading } from '../review-list/components/loading/ReviewListLoading'

export class ReviewDeleteDto { Password = ''; ConfirmPassword = ''; }

type Props = {
  isReviewLoading: boolean
  id: ID
}

const ReviewDeleteModal: FC<Props> = ({ isReviewLoading, id }) => {
  const reviewDeleteSchema = Yup.object().shape({
  })

  const [objectReviewDeleteDto] = useState(new ReviewDeleteDto())
  const queryClient = useQueryClient()
  const {query} = useQueryResponse()

  const formik = useFormik({
    initialValues: objectReviewDeleteDto,
    validationSchema: reviewDeleteSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        var reviewDeleteResult = await updateReviewStatus(id, "1", 3)

        if (reviewDeleteResult !== null && reviewDeleteResult !== undefined) {
          var el = document.getElementById('kt_modal_reviewDelete_cancel'+id);
          el?.click();
          queryClient.invalidateQueries([`${QUERIES.REVIEW_LIST}-${query}`])
        }
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(ex.message);
        } else {
          console.log('Unexpected error', ex);
        }
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <div className='modal fade' id={'kt_modal_reviewDelete'+id} aria-hidden='true'>
      <div className='modal-dialog modal-l'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Delete Review')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >
                <div className='card-body border-top'>
                  <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed mb-6 p-6'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2tx svg-icon-warning me-4'
                    />

                    <div className='d-flex flex-stack flex-grow-1' style={{ textAlign: "left" }}>
                      <div className='fw-bold'>
                        <h4 className='text-gray-800 fw-bolder'>{LanguageHelp('You Are Deleting This Review')}</h4>
                        <div className='fs-6 text-gray-600'>
                          {LanguageHelp('You cannot undo this action. If you still want to delete it, you can delete the review from the button below.')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* end::Scroll */}
              {/* begin::Actions */}
              <div className='text-center pb-5'>

                {/* begin::Close */}
                <button type='reset' id={'kt_modal_reviewDelete_cancel'+id} className='btn btn-light me-3' data-bs-dismiss='modal'>
                  {LanguageHelp('Cancel')}
                </button>
                {/* end::Close */}
                <button
                  type='submit'
                  className='btn btn-danger'
                  data-kt-users-modal-action='submit'
                  disabled={isReviewLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  <span className='indicator-label'>{LanguageHelp('Delete Review')}</span>
                  {(formik.isSubmitting || isReviewLoading) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
            {(formik.isSubmitting || isReviewLoading) && <ReviewListLoading />}
          </div>
        </div></div>
    </div>
  )
}

export { ReviewDeleteModal }
